module.exports = __webpack_public_path__ + "static/media/settings-purple.2090a4c5.svg";